import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createCasePaper,
  getCasePaperByVisit,
  mapCasePaperToForm,
  updateCasePaper,
} from "../../services/casePaperService";

const initialState = {
  detail: null,
  formDefaults: null,
  casePaperId: null,
  loading: false,
  saving: false,
  error: null,
};

export const loadCasePaperByVisit = createAsyncThunk(
  "casePaper/loadByVisit",
  async (visitId, { rejectWithValue }) => {
    try {
      const detail = await getCasePaperByVisit(visitId);
      return {
        detail,
        formDefaults: mapCasePaperToForm(detail),
        casePaperId: detail?.header?.casePaperId ?? null,
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const saveCasePaper = createAsyncThunk(
  "casePaper/save",
  async ({ casePaperId, payload }, { rejectWithValue }) => {
    try {
      if (casePaperId) {
        return await updateCasePaper(casePaperId, payload);
      }
      return await createCasePaper(payload);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const casePaperSlice = createSlice({
  name: "casePaper",
  initialState,
  reducers: {
    clearCasePaper: (state) => {
      state.detail = null;
      state.formDefaults = null;
      state.casePaperId = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadCasePaperByVisit.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loadCasePaperByVisit.fulfilled, (state, action) => {
        state.loading = false;
        state.detail = action.payload.detail;
        state.formDefaults = action.payload.formDefaults;
        state.casePaperId = action.payload.casePaperId;
      })
      .addCase(loadCasePaperByVisit.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load case paper";
      })
      .addCase(saveCasePaper.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(saveCasePaper.fulfilled, (state, action) => {
        state.saving = false;
        state.casePaperId = action.payload?.casePaperId ?? state.casePaperId;
      })
      .addCase(saveCasePaper.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload || "Failed to save case paper";
      });
  },
});

export const { clearCasePaper } = casePaperSlice.actions;
export default casePaperSlice.reducer;
